export const initFormValues = {
  community: null,
  cleanKind: null,
  startTime: null,
  endTime: null,
};
